import React from 'react'
import Layout from './Layout'
import { Link } from 'react-router-dom'

export default function InnovationDesignThinking() {
  return (
    <Layout page={<div>
      <h1>Innovation & Design Thinking</h1>
      <h3>Model Papers</h3>
      <ul>
        <Link to='/file/idt/21IDT19set1.pdf'>21IDT19set1.pdf</Link>
        <Link to='/file/idt/21IDT19set2.pdf'>21IDT19set2.pdf</Link>
      </ul>
      <h6><Link to='/contact'>Contact developer</Link> to add more notes.</h6>
    </div>} />
  )
}
